import escape from 'lodash.escape';
import Cookies from 'js-cookie'

//if php backend thinks domain is valid
const isDomainSetAsValid = (domainName) => {
    const selector = '#menu-container a[data-domain="' + domainName + '"] .text-success';
    return !!document.querySelector(selector);
}

const isAlreadyValidatedByAjax = (domainName) => {
    return Cookies.get('validatedByAjax-' + domainName)
}

const setValidatedByAjax = (domainName) => {
    Cookies.set('validatedByAjax-' + domainName, true);
}


const lookup = (lookupInstance, lookupType) => {
    lookupInstance.getLookup(lookupType, function (result, records) {
        try {
        let status = $('.' + lookupType + '-status');
        let content = status.data(lookupType + 'Content')[result];
        status.addClass(content['class']);
        status.find('.' + lookupType + '-label').text(content['label']);
        status.find('.fa').removeClass('fa-spinner fa-spin').addClass(content['icon']);

        let record = $('.' + lookupType + 'Record');
        if (result !== 'valid') {
            record.find('.not-valid').addClass('show-record');

            let actualRecords = $('.' + lookupType + 'Record .actualRecords');
            if (records) {
                records.forEach(function (item, id, records) {
                    actualRecords.append('<span>' + escape(item) + '</span>');
                    //if not last
                    if (id !== records.length - 1) {
                        if (lookupType === 'txt') {
                            actualRecords.append('<hr>');
                        } else {
                            actualRecords.append('<br>');
                        }
                    }
                });
            }

            const statusTranslations = record.find('.actualStatus').data('translations');
            record.find('.actualStatus').html(statusTranslations[result] ? statusTranslations[result] : '');
        } else {
            const hostnameValidated = euAdminConfig.hostname;
            if (!isAlreadyValidatedByAjax(hostnameValidated) && !isDomainSetAsValid(hostnameValidated)) {
                //set cookie for current browser session so we don't get redirect loops
                // if backend still thinks it is not validated domain
                setValidatedByAjax(hostnameValidated);
                const currLang =  window.location.pathname.split('/')[1] ?? 'en';
                //force re-validate if valid via ajax but not yet valid otherwise
                window.location = '/' + currLang + '/'  + hostnameValidated +  '/validation/validate?type=' + lookupType;
            }
            console.log('NOT appending '+lookupType+' as it is valid ');

            record.find('.valid').addClass('show-record');
        }

        record.find('.modal-spinner').hide();
        } catch (e) {
            console.log('Error in lookup', e);
        }
    })
};

export default lookup;
